// extracted by mini-css-extract-plugin
export var footer = "_q4-0";
export var inherit = "_q4-1";
export var input = "_q4-2";
export var modalContent = "_q4-3";
export var quillEditor = "_q4-4";
export var subtitle = "_q4-5";